<template>
    <v-container>
        <v-layout
                text-center
                wrap
        >
            <!--div v-html="content"> </div-->
            <div id="block-berechnung-content" class="ui-block-b" role="main">
                <h2 class="subsection">Zu- und Abschläge in Euro pro m² und Monat</h2>
                <h3>Wohnlage nach beigefügtem Stadtplan</h3>
                <p>(höchstens eines der Merkmale kann zutreffen)</p>

                <table class="zuAbschlaege" data-role="table" data-mode="reflow">
                  <thead>
                    <tr>
                      <th class="zuAbschlaege-column-a" data-priority="1">Merkmal</th>
                      <th class="zuAbschlaege-column-b" data-priority="persist">Betrag</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="zuAbschlaege-column-a">Durchschnittliche Lage (im Stadtplan hellblau markiert)</td>
                      <td class="zuAbschlaege-column-b">+/-0,00</td>
                    </tr>
                    <tr>
                      <td class="zuAbschlaege-column-a">Gute Lage (im Stadtplan gelb markiert)</td>
                      <td class="zuAbschlaege-column-b">+0,43</td>
                    </tr>
                    <tr>
                      <td class="zuAbschlaege-column-a">Beste Lage (im Stadtplan hellrot markiert)</td>
                      <td class="zuAbschlaege-column-b">+2,10</td>
                    </tr>
                    <tr>
                      <td class="zuAbschlaege-column-a">Zentrale durchschnittliche Lage (im Stadtplan dunkelblau markiert)</td>
                      <td class="zuAbschlaege-column-b">+0,80</td>
                    </tr>
                    <tr>
                      <td class="zuAbschlaege-column-a">Zentrale gute Lage (im Stadtplan orange markiert)</td>
                      <td class="zuAbschlaege-column-b">+2,29</td>
                    </tr>
                    <tr>
                      <td class="zuAbschlaege-column-a">Zentrale beste Lage (im Stadtplan dunkelrot markiert)</td>
                      <td class="zuAbschlaege-column-b">+2,70</td>
                    </tr>
                  </tbody>
                </table>

                <br/>
                <h3>Gebäudetypen</h3>
                <p>(höchstens eines der Merkmale kann zutreffen)<br>
                  <b>Hinweis:</b> Ein mindestens teilweise ausgebauter Speicher/Dachboden zählt als Stockwerk.  
                </p>

                <table class="zuAbschlaege" data-role="table" data-mode="reflow">
                  <thead>
                    <tr>
                      <th class="zuAbschlaege-column-a" data-priority="1">Merkmal</th>
                      <th class="zuAbschlaege-column-b" data-priority="persist">Betrag</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="zuAbschlaege-column-a">
                          <strong>Hochhaus oder höheres Gebäude:</strong>
                          Nach 1948 und vor 1999 fertiggestelltes Gebäude mit mindestens sechs Stockwerken zusätzlich zum Erdgeschoss (E+6). 
                          Das Gebäude ist freistehend oder grenzt mit mindestens einer Seite an ein anderes Gebäude gleicher Bauart an (dies muss nicht zwingend ein Hochhaus oder ein höheres Gebäude sein).
                      </td>
                      <td class="zuAbschlaege-column-b">-0,96</td>
                    </tr>
                    <tr>
                      <td class="zuAbschlaege-column-a">
                        <strong>Wohnblock:</strong><br>
                        <strong>a) Freistehender Wohnblock:</strong>
                        Freistehendes Gebäude ohne Aufzug mit größerer zum Gebäude gehöriger Grünfläche oder gärtnerisch angelegter Fläche 
                        (nicht nur schmaler Grünstreifen) mit mehr als zwei Hausnummern und höchstens 5 Stockwerken zusätzlich zum Erdgeschoss (E+5).
                        <br><br>
                        <strong>b) Zusammenhängender Wohnblock:</strong>
                        Mit mindestens einer Seite an ein anderes Gebäude gleicher Bauart angrenzendes Gebäude ohne Aufzug mit größerer zum Gebäude gehöriger 
                        Grünfläche oder gärtnerisch angelegter Fläche (nicht nur schmaler Grünstreifen) mit mehr als fünf Wohnungen (hier ist die Hausnummer 
                        des Gebäudes gemeint, in der sich die Wohnung befindet) und höchstens 5 Stockwerken zusätzlich zum Erdgeschoss (E+5).
                      </td>
                      <td class="zuAbschlaege-column-b">-1,13</td>
                    </tr>
                  </tbody>
                </table>

                <br/>
                <h3>Durch Ausstattungsmerkmale charakterisierte Haustypen</h3>
                <p>
                    (genau einer der fünf Haustypen muss gewählt werden) <br/>
                    <strong>Hinweis:</strong> Zur Beurteilung der Frage, ob ein vorhandener Speicher/Dachboden zu Wohnzwecken nicht oder nur teilweise ausgebaut wurde, 
                    kommt es auf einen vorhandenen Spitzboden/Dachspitz nicht an.
                </p>

                <table class="zuAbschlaege" data-role="table" data-mode="reflow">
                  <thead>
                    <tr>
                      <th class="zuAbschlaege-column-a" data-priority="1">Merkmal</th>
                      <th class="zuAbschlaege-column-b" data-priority="persist">Betrag</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="zuAbschlaege-column-a"><strong>Sehr einfacher Altbau:</strong>
                        Wohnung in einem Gebäude mit einem Baujahr vor 1949 und einem vorhandenen, aber zu Wohnzwecken nicht oder nur 
                        teilweise ausgebauten Speicher/Dachboden. Die Wohnung verfügt nicht über Stuck an Wand und/oder Decke, die Höhe 
                        der Wohnräume ist höchstens 2,90m und der größte Wohnraum hat eine Fläche von höchstens 20m².
                      </td>
                      <td class="zuAbschlaege-column-b">-2,58</td>
                    </tr>
                    <tr>
                      <td class="zuAbschlaege-column-a"><strong>Einfacher Altbau:</strong><br>
                        <strong>a) Wohnung in einem Gebäude mit einem Baujahr vor 1949 und einem vorhandenen, aber zu Wohnzwecken nicht 
                          oder nur teilweise ausgebauten Speicher/Dachboden.</strong> Die Wohnung verfügt über mindestens eines der 
                          drei Merkmale: Stuck an Wand und/oder Decke, die Höhe des größten Wohnraums ist über 2,90m oder die Fläche 
                          des größten Wohnraums ist größer als 20m².
                        <br><br>
                        <strong>b) Wohnung in einem Gebäude mit einem Baujahr vor 1949, bei dem ein vorhandener Speicher/Dachboden 
                          vollständig ausgebaut oder kein Speicher/Dachboden vorhanden ist.</strong> Die Wohnung verfügt nicht über 
                          Stuck an Wand und/oder Decke, die Höhe der Wohnräume ist höchstens 2,90m und der größte Wohnraum hat eine 
                          Fläche von höchstens 20m².
                      </td>
                      <td class="zuAbschlaege-column-b">-1,21</td>
                     </tr>
                     <tr>
                      <td class="zuAbschlaege-column-a"><strong>Guter Altbau:</strong> <br>
                        Wohnung in einem Gebäude mit einem Baujahr vor 1949, bei dem ein vorhandener Speicher/Dachboden vollständig 
                        ausgebaut oder kein Speicher/Dachboden vorhanden ist. Die Wohnung verfügt über mindestens eines der drei 
                        Merkmale: Stuck an Wand und/oder Decke, die Höhe des größten Wohnraums ist über 2,90m oder die Fläche des 
                        größten Wohnraums ist größer als 20m².
                        <br><br>
                        <strong>Hinweise:</strong> Zur Einordung von Altbauten siehe unteres Schema.
                        <br><br>
                        Im Zweifel ist für die Raumhöhe die höchste Stelle des
                        größten Wohnraums maßgeblich (Bad, Flur, WC und (Wohn-)Küche bleiben außer Betracht). Dachschrägen werden 
                        nicht berücksichtigt.
                        <br><br>
                        Stuck ist vorhanden, wenn die Wohnung an mindestens einer Stelle über Stuck an Wand oder Decke verfügt.
                      </td>
                      <td class="zuAbschlaege-column-b">+0,36</td>
                     </tr>
                     <tr>
                      <td class="zuAbschlaege-column-a"><strong>Einfacher Nachkriegsbau:</strong> <br>
                        Wohnung in einem Gebäude mit einem Baujahr nach 1948 und vor 1978 und einem vorhandenen, aber zu Wohnzwecken 
                        nicht oder nur teilweise ausgebauten Speicher/Dachboden.
                      </td>
                      <td class="zuAbschlaege-column-b">-1,14</td>
                     </tr>
                     <tr>
                      <td class="zuAbschlaege-column-a"><strong>Anderer Haustyp:</strong>
                        Wohnung in einem Gebäude mit einem Baujahr nach 1948, welche nicht unter das Merkmal „Einfacher Nachkriegsbau“ 
                        fällt.
                      </td>
                      <td class="zuAbschlaege-column-b">+/-0,00</td>
                    </tr>
                  </tbody>
                </table>

                <br>
                <p>
                    <b>Wohnungen in Gebäuden mit Baujahr vor 1949 lassen sich nach folgendem Schema einordnen:</b>
                </p>

                <table class="zuAbschlaege" data-role="table" data-mode="reflow">
                    <thead>
                        <tr>
                          <th class="whiteTable"></th>
                          <th class="whiteTable">Ohne eines der<br> genannten Stilelemente</th>
                          <th class="whiteTable">Mit mindestens<br> einem der genannten Stilelemente</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td class="whiteTable"> <strong>Speicher/Dachboden nicht oder teilweise zu Wohnzwecken ausgebaut</strong> </td>
                            <td class="whiteTable"> Sehr einfacher Altbau </td>
                            <td class="whiteTable"> Einfacher Altbau </td>
                        </tr>
                        <tr>
                            <td class="whiteTable"> <strong>Speicher/Dachboden vollständig zu Wohnzwecken ausgebaut oder nicht vorhanden</strong> </td>
                            <td class="whiteTable"> Einfacher Altbau </td>
                            <td class="whiteTable"> Guter Altbau </td>
                        </tr>
                    </tbody>
                </table>

                <br/>
                <h3>Heizung</h3>
                <p>
                    <strong>Hinweis:</strong> Wohnungen, die über keine von der*dem Vermieter*in gestellten Beheizungsmöglichkeiten 
                    verfügen, fallen nicht unter den Anwendungsbereich des Mietspiegels für München 2025.
                </p>
                <br/>

                <table class="zuAbschlaege" data-role="table" data-mode="reflow">
                  <thead>
                    <tr>
                      <th class="zuAbschlaege-column-a" data-priority="1">Merkmal</th>
                      <th class="zuAbschlaege-column-b" data-priority="persist">Betrag</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="zuAbschlaege-column-a">
                        <strong>Unvollständige Beheizung:</strong> <br>
                        In mindestens einem Wohnraum gibt es keine von der*dem Vermieter*in gestellte Beheizungsmöglichkeit. Für eine 
                        Anwendung der „Unvollständigen Beheizung“ sind nur die Wohnräume zu betrachten. Die Beheizungsmöglichkeit in 
                        Bad, WC, Flur und (Wohn-) Küche wird nicht berücksichtigt. Bei mehr als vier Wohnräumen sind nur die vier 
                        größten Wohnräume ausschlaggebend.
                      </td>
                      <td class="zuAbschlaege-column-b">-2,21</td>
                    </tr>
                     <tr>
                      <td class="zuAbschlaege-column-a">
                          <strong>Fußbodenheizung:</strong><br>
                          (das Merkmal „Fußbodenheizung“ kann neben dem Merkmal „Unvollständige Beheizung“ angesetzt werden)
                          Wohnung in einem Gebäude mit einem Baujahr vor 1999, die über eine Fußbodenheizung verfügt.
                      </td>
                      <td class="zuAbschlaege-column-b">+1,00</td>
                     </tr>
                  </tbody>
                </table>

                <br/>
                <h3>Sanitärbereich</h3>
                <p>(alle Merkmale können nebeneinander angesetzt werden)</p>

                <table class="zuAbschlaege" data-role="table" data-mode="reflow">
                  <thead>
                    <tr>
                      <th class="zuAbschlaege-column-a" data-priority="1">Merkmal</th>
                      <th class="zuAbschlaege-column-b" data-priority="persist">Betrag</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="zuAbschlaege-column-a"><strong>Besondere Zusatzausstattung im Bad vorhanden:</strong>
                        Es muss zusätzlich zur Badewanne eine separate Dusche und ein zweites Waschbecken (beziehungsweise 
                        Doppelwaschbecken) und/oder ein Bidet vorhanden sein.
                      </td>
                      <td class="zuAbschlaege-column-b">+0,62</td>
                    </tr>
                    <tr>
                     <td class="zuAbschlaege-column-a"><strong>Handtuchheizkörper (nicht mit Strom betrieben) vorhanden:</strong>
                      </td>
                      <td class="zuAbschlaege-column-b">+0,62</td>
                    </tr>
                    <tr>
                     <td class="zuAbschlaege-column-a"><strong>Separate bodengleiche Dusche:</strong>
                      </td>
                      <td class="zuAbschlaege-column-b">+0,62</td>
                    </tr>
                    <tr>
                     <td class="zuAbschlaege-column-a"><strong>Fläche des (größten) Bades beträgt
                     mindestens 6m² und/oder zweites ausgestattetes Bad vorhanden:</strong><br>
                     Ein ausgestattetes Bad ist ein abgeschlossener Raum der Wohnung mit mindestens einer Badewanne oder
                     Dusche.
                     </td>
                     <td class="zuAbschlaege-column-b">+0,62</td>
                    </tr>
                    <tr>
                     <td class="zuAbschlaege-column-a"><strong>Modernisiertes Bad:</strong><br>
                      Wohnung in einem Gebäude mit einem Baujahr vor 1999, bei der 2019 oder später das Bad modernisiert 
                      beziehungsweise instandgesetzt wurde. Die Modernisierung beziehungsweise Instandsetzung muss mindestens 
                      Badewanne und/oder Dusche sowie Wand- und Bodenbeläge umfassen.
                     </td>
                     <td class="zuAbschlaege-column-b">+0,62</td>
                    </tr>
                  </tbody>
                </table>

                <br/>
                <h3>Küche</h3>
                <p>
                  (die Merkmale „Offene Küche“ und „Küchenausstattung“ können nebeneinander angesetzt werden) <br>
                  <strong>Hinweis:</strong> Im Folgenden bezeichnet Küche sowohl eine Kochnische, Wohnküche, separate Küche als auch offene Küche.
                </p>

                <table class="zuAbschlaege" data-role="table" data-mode="reflow">
                  <thead>
                    <tr>
                      <th class="zuAbschlaege-column-a" data-priority="1">Merkmal</th>
                      <th class="zuAbschlaege-column-b" data-priority="persist">Betrag</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="zuAbschlaege-column-a"><strong>Offene Küche:</strong>
                        Wohnung verfügt über eine zum Ess-/Wohnraum offene Küche (Funktion: Kochen, Essen, Wohnen. Der Küchenbereich 
                        ist optisch und funktional vom Ess-/Wohnbereich eindeutig unterscheidbar.). Die Ausstattung der Küche spielt 
                        dabei keine Rolle. Eine im Wohnraum integrierte Kochnische oder Kochgelegenheit fällt nicht unter das Merkmal 
                        „Offene Küche“.
                      </td>
                      <td class="zuAbschlaege-column-b">+0,55</td>
                    </tr>
                    <tr>
                      <td class="zuAbschlaege-column-a"><strong>Küchenausstattung:</strong>
                        Zuschläge für die nachfolgenden Elektrogeräte dürfen nur vergeben werden, wenn die*der Vermieter*in als 
                        Grundausstattung eine Spülmöglichkeit und Einbauschränke zur Verfügung gestellt hat. Die Einbauschränke 
                        können auch in Form einer Kücheninsel/eines Küchenblocks zur Verfügung gestellt werden.
                        <br><br>
                        <strong>Folgende Elektrogeräte können berücksichtigt werden:</strong>
                          (Die Zuschläge a), b) und c) dürfen beim Vorliegen der Voraussetzungen nebeneinander angesetzt
                          werden)
                      </td>
                      <td class="zuAbschlaege-column-b"></td>
                    </tr>
                    <tr>
                      <td class="zuAbschlaege-column-a"><strong>a) Glaskeramik-Kochmulde (Ceranfeld) oder Induktionskochfeld:</strong>
                      </td>
                      <td class="zuAbschlaege-column-b">+0,53</td>
                    </tr>
                    <tr>
                      <td class="zuAbschlaege-column-a"><strong>b) Kühlschrank oder Kühl-/Gefrierkombination:</strong>
                      </td>
                      <td class="zuAbschlaege-column-b">+0,53</td>
                    </tr>
                    <tr>
                      <td class="zuAbschlaege-column-a"><strong>c) Geschirrspülmaschine:</strong>
                      </td>
                      <td class="zuAbschlaege-column-b">+0,53</td>
                    </tr>
                  </tbody>
                </table>

                <br/>
                <h3>Fußboden</h3>
                <p>
                  <strong>Hinweise:</strong> Es werden nur Wohnräume betrachtet. Der Fußbodenbelag in Bad, Flur, WC und (Wohn-)Küche 
                  wird nicht berücksichtigt. Bei Wohnungen mit mehr als vier Wohnräumen sind nur die vier größten Wohnräume 
                  ausschlaggebend.
                </p>

                <table class="zuAbschlaege" data-role="table" data-mode="reflow">
                  <thead>
                    <tr>
                      <th class="zuAbschlaege-column-a" data-priority="1">Merkmal</th>
                      <th class="zuAbschlaege-column-b" data-priority="persist">Betrag</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="zuAbschlaege-column-a"><strong>Ohne Fußbodenbelag:</strong>
                          Die Wohnung besitzt mindestens einen Wohnraum ohne einen von der*dem Vermieter*in gestellten
                          Fußbodenbelag.
                      </td>
                      <td class="zuAbschlaege-column-b">-1,54</td>
                    </tr>
                    <tr>
                      <td class="zuAbschlaege-column-a"><strong>Einfacher Boden:</strong>
                        Die Wohnung besitzt in allen Wohnräumen einen von der*dem Vermieter*in gestellten Fußbodenbelag und in 
                        mehr als der Hälfte der Wohnräume entweder einen Teppich- oder PVC-/Vinylboden.
                      </td>
                      <td class="zuAbschlaege-column-b">-1,12</td>
                    </tr>
                    <tr>
                      <td class="zuAbschlaege-column-a"><strong>Guter Boden:</strong>
                        Die Wohnung besitzt in jedem Wohnraum einen von der*dem Vermieter*in gestellten 
                        Parkett-/Laminat-/hochwertigen Holzdielenboden oder Naturstein-/Fliesenboden.
                      </td>
                      <td class="zuAbschlaege-column-b">+1,37</td>
                    </tr>
                    <tr>
                      <td class="zuAbschlaege-column-a"><strong>Weder „Ohne Fußbodenbelag“ noch „Einfacher Boden“ beziehungsweise „Guter Boden“:</strong>
                          Es ist weder die Definition des Merkmals „Ohne Fußbodenbelag“ noch die des Merkmals
                          „Einfacher Boden“ beziehungsweise des Merkmals „Guter Boden“ erfüllt.<br>
                          <br>
                        <strong>Hinweise:</strong> Genau eines der vier vorstehenden Merkmale zum Fußbodenbelag muss
                          gewählt werden. Zusätzliche Begründungen sind im Schritt Begründete Abweichungen möglich.
                      </td>
                      <td class="zuAbschlaege-column-b">+/-0,00</td>
                    </tr>
                    <tr>
                      <td class="zuAbschlaege-column-a"><strong>Modernisierter Boden:</strong>
                        Wohnung in einem Gebäude mit einem Baujahr vor 2019, bei der in allen Wohnräumen der Fußbodenbelag 2019 oder 
                        später von der*dem Vermieter*in modernisiert oder instandgesetzt worden ist. <br>
                        <strong>Hinweis:</strong> Der Zuschlag ist unabhängig von der Art des Fußbodenbelags.
                      </td>
                      <td class="zuAbschlaege-column-b"> +1,86</td>
                    </tr>
                  </tbody>
                </table>

                <br/>
                <h3>Terrasse/Dachterrasse/Balkon/Loggia</h3>
                <br/>

                <table class="zuAbschlaege" data-role="table" data-mode="reflow">
                  <thead>
                    <tr>
                      <th class="zuAbschlaege-column-a" data-priority="1">Merkmal</th>
                      <th class="zuAbschlaege-column-b" data-priority="persist">Betrag</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="zuAbschlaege-column-a">
                        <strong>Terrasse/Dachterrasse beziehungsweise Balkon/Loggia</strong><br>
                          Wohnung in einem Gebäude mit einem Baujahr vor 1999, die über mindestens eine Terrasse beziehungsweise 
                          Dachterrasse oder mindestens einen Balkon beziehungsweise eine Loggia verfügt und deren jeweilige Fläche 
                          mindestens 1m² beträgt.
                      </td>
                      <td class="zuAbschlaege-column-b">+0,55</td>
                    </tr>
                  </tbody>
                </table>

                <br/>
                <h3>Weitere Merkmale</h3>
                <br/>

                <table class="zuAbschlaege" data-role="table" data-mode="reflow">
                  <thead>
                    <tr>
                        <th class="zuAbschlaege-column-a" data-priority="1">Merkmal</th>
                        <th class="zuAbschlaege-column-b" data-priority="persist">Betrag</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="zuAbschlaege-column-a">
                          <strong>Besondere Ausstattung:</strong><br>
                          Wohnung in einem Gebäude mit mindestens einem der folgenden von der*dem Vermieter*in gestellten 
                          Ausstattungsmerkmale:
                          <ul>
                            <li>
                              Mindestens ein elektrisch betriebener Rollladen beziehungsweise eine elektrisch betriebene Jalousie.
                            </li>
                            <li>
                              Videogegensprechanlage.
                            </li>
                          </ul>
                      </td>
                      <td class="zuAbschlaege-column-b">+0,77</td>
                    </tr>
                    <tr>
                      <td class="zuAbschlaege-column-a">
                        <strong>Modernisierte Fenster:</strong><br>
                        Wohnung in einem Gebäude mit einem Baujahr vor 1949, bei der alle Fenster 1995 oder später eingebaut wurden 
                        und 2019 oder später mindestens die Hälfte der Fenster von der*dem Vermieter*in modernisiert beziehungsweise 
                        instandgesetzt wurden.
                      </td>
                      <td class="zuAbschlaege-column-b">+2,10</td>
                    </tr>
                  </tbody>
                </table>
            </div>

        </v-layout>
    </v-container>
</template>

<style>
    @import '../mietspiegel.css';
</style>

<script lang="ts">
    import {Component, Vue} from 'vue-property-decorator';


    @Component
    export default class ZuUndAbschlaege extends Vue {

    }
</script>